import { getCmpVendorId } from '../../utils/cmp-vendors';
import { satelliteTracker } from '../../services/tracking/satellite-tracking-service';
import { isLiveBlogScribble } from '../../utils/aem-utils';

export const embedsSelectors = {
  instagram: '.s-embed-instagram',
  facebook: '.s-embed-facebook',
  twitter: '.s-embed-twitter',
  megaphone: '.s-embed-megaphone',
  youtube: '.s-embed-youtube, .youtube-post',
  typeform: '.s-embed-typeform',
};

const getCmpVendorSelector = (vendorName) => embedsSelectors[vendorName] || '';

/**
 * name: vendor's name
 * id: used to trigger skyCMP changes
 * selector: html selector for DOM queries
 */
export default [
  {
    name: 'instagram',
    id: getCmpVendorId('instagram'),
    selector: getCmpVendorSelector('instagram'),
  },
  {
    name: 'facebook',
    id: getCmpVendorId('facebook'),
    selector: getCmpVendorSelector('facebook'),
  },
  {
    name: 'twitter',
    id: getCmpVendorId('twitter'),
    selector: getCmpVendorSelector('twitter'),
    callback: () => {
      if (isLiveBlogScribble()) {
        // Workaround to inject the script only on Twitter - only legacy Scribble liveblog pages
        const $script = document.createElement('script');
        $script.setAttribute('src', 'https://platform.twitter.com/widgets.js');
        const $firstBlockquoteTwitter = document.querySelector('.twitter-tweet');
        $firstBlockquoteTwitter?.insertAdjacentElement('afterend', $script);
      }
    },
  },
  {
    name: 'megaphone',
    id: getCmpVendorId('megaphone'),
    selector: getCmpVendorSelector('megaphone'),
  },
  {
    name: 'youtube',
    id: getCmpVendorId('youtube'),
    selector: getCmpVendorSelector('youtube'),
  },
  {
    initialized: false,
    id: getCmpVendorId('typeform'),
    selector: getCmpVendorSelector('typeform'),
  },
];
